<div class="dc-multisession-conflict-dialog">
    <div class="popup-header">
        <h1>{{ 'sessionLifecycle.multisessionTitle' | translate }}</h1>
    </div>
    <mat-dialog-content>
        <div class="popup-content">
            {{ 'sessionLifecycle.multisessionText' | translate }}
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="start" class="contract-popup-buttons">
        <div class="action-bottom-buttons">
            <button class="btn blue" type="button" [mat-dialog-close]="false">
                {{ 'sessionLifecycle.cancelLogin' | translate }}
            </button>
            <button class="btn green" type="button" [mat-dialog-close]="true">
                {{ 'sessionLifecycle.terminatePreviousSession' | translate }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
